export default __webpack_public_path__ + "static/media/burger.6ce78424.svg";